export default {
	customers: (state) => state.customers
}
